import { useEffect, useState } from "react";
import { subscribePublishedPosts, subscribeAllPosts } from "../data/firestore";

/** `all: true` includes drafts — pass only from the admin panel. */
export default function useBlogPosts({ all = false } = {}) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const subscribe = all ? subscribeAllPosts : subscribePublishedPosts;
    const unsub = subscribe((data) => {
      setPosts(data);
      setLoading(false);
    });
    return unsub;
  }, [all]);

  return { posts, loading, hasPosts: posts.length > 0 };
}
